import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { get } from "lodash";
import {ActionType} from "../vss-ui.enum";

export class InvalidFormError extends Error { }

export class ObjUtil {
  static deleteNullProp(obj: any) {
    for (const prop in obj) {
      if (obj[prop] == null || obj[prop]?.length === 0) {
        delete obj[prop];
      }
    }
    return obj;
  }

  static trim(obj: any): any {
    return JSON.parse(JSON.stringify(obj).replace(/\"\s+|\s+\"/g, '"'));
  }

  static join(arr: any[], key = 'name'): any {
    return arr.map((item) => get(item, key)).join(', ');
  }

  static getFirstObjInArray(arr: any[]) {
    return arr?.length ? arr[0] : null
  }
}

export class Ultilities {

  static validateForm(form: FormGroup) {
    for (const key in form.controls) {
      form.controls[key].markAsDirty();
      form.controls[key].updateValueAndValidity();
      if (form.controls[key] instanceof FormGroup) {
        this.validateForm(form.controls[key] as FormGroup);
      }
      if (form.controls[key] instanceof FormArray) {
        for (const item of (form.controls[key] as FormArray).controls) {
          if (item instanceof FormControl) {
            item.markAsDirty();
            item.updateValueAndValidity();
          } else if (item instanceof FormGroup) {
            this.validateForm(item as FormGroup);
          }
        }
      }
    }
  }

  static disableControls(form: FormGroup, controls: string[]) {
    controls.forEach(name => { form.get(name)?.disable() });
  }

  static enableControls(form: FormGroup, controls: string[]) {
    controls.forEach(name => { form.get(name)?.enable() });
  }

  static getFieldName(name: string) {
    return this.removeVietnameseAccents(name.trim(), '_').replace(/\W/g, '')
  }
  static replaceEN(value: string, searchValue: string, replaceValue: string) {
    if(!searchValue) return  value
    let res = ''
    const valueEN = Ultilities.vn2en(value)
    const searchEN = Ultilities.vn2en(searchValue)
    const positions = this.getIndexsText(valueEN, new RegExp(searchEN, 'gi'))
    if(positions?.length) {
      res = positions?.length ? value.slice(0, positions[0]) : value
      positions.forEach(
        (i, k) => {
          res = `${res}${k > 0 ? value.slice((positions[k - 1]) + searchValue.length, i) : ''}${replaceValue.replace(/\{\{value}}/g, value.slice(i, i + searchValue.length))}`
        }
      )
      res = `${res}${value.slice(positions[positions.length - 1] + searchValue.length, value.length)}`
    } else res = value
    return res
  }
  static getIndexsText(str: string, regex: RegExp) {
    let positions = [];
    let match;
    while ((match = regex.exec(str)) !== null) {
      positions.push(match.index);
    }
    return positions
  }
  static vn2en(vnText: string) {
    let str = vnText;
    if (str === undefined || str === null || str === '') {
      return '';
    }
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(new RegExp(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g.source.toUpperCase(), 'g'), 'A');

    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(new RegExp(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g.source.toUpperCase(), 'g'), 'E');

    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(new RegExp(/ì|í|ị|ỉ|ĩ/g.source.toUpperCase(), 'g'), 'I');

    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(new RegExp(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g.source.toUpperCase(), 'g'), 'O');

    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(new RegExp(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g.source.toUpperCase(), 'g'), 'U');

    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(new RegExp(/ỳ|ý|ỵ|ỷ|ỹ/g.source.toUpperCase(), 'g'), 'Y');

    str = str.replace(/đ/g, 'd');
    str = str.replace(/Đ/g, 'D');
    return str
  }

  static removeVietnameseAccents(obj: string, reSpace = '', toLower = true) {
    let str = obj;
    if (str === undefined || str === null || str === '') {
      return '';
    }
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    // str= str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'| |\"|\&|\#|\[|\]|~|$|_/g,"-");
    // tìm và thay thế các kí tự đặc biệt trong chuỗi sang kí tự - /
    // str= str.replace(/-+-/g,"-"); //thay thế 2- thành 1-
    str = str.replace(/^(\-+|\-+)$/g, '');
    // cắt bỏ ký tự - ở đầu và cuối chuỗi
    str = str.replace(new RegExp('\\s+', 'g'), ' ');
    if (reSpace) {
      str = str.replace(new RegExp(' ', 'g'), reSpace);
    }
    str = str.trim();
    if (toLower !== null) {
      if (toLower) {
        str = str.toLowerCase();
      }
      else {
        str = str.toUpperCase();
      }
    }
    return str;
  }

  static convertNzOption(data: any[], fieldId: string = 'id', fieldName: string = 'name', isShowId: boolean = false): any {
    if (data) {
      return data.map(x => ({ label: (isShowId ? (x[fieldId] + ' - ') : '') + x[fieldName], value: x[fieldId], init: data }));
    }
    return [];
  }

  static distinctData(data: any[], fieldId: string): any[] {
    if (data) {
      const map = new Map();
      const list: any[] = [];
      data.forEach((x: any) => {
        if (x[fieldId]) {
          map.set(x[fieldId], x);
        }
      });
      map.forEach((value, key, map) => {
        list.push(value);
      });
      return list;
    }
    return [];
  }

  static getTitlePopup(type: ActionType): string {
    if (type == ActionType.UPDATE) {
      return "Cập nhật";
    } else if (type == ActionType.VIEW) {
      return "Thông tin chi tiết";
    }
    return "Thêm mới";
  }

  /**
   * True ==> obj1 != obj2
   * False ==> obj1 == obj2
   * @param obj1
   * @param obj2
   * @return boolean
   */
  static compareObject(obj1: any, obj2:any): boolean {
    return !!Object.keys(obj1).concat(Object.keys(obj2)).find(k => obj1[k] !== obj2[k])
  }

  static getFileExtension(fileName: string): string {
    if (!fileName.includes('.')) {
      return '';
    }
    return fileName.toLowerCase().split('.').pop() || '';
  }

  static isAllowedExtension(fileName: string, allowedExtList: string[]): boolean {
    const fileExt = Ultilities.getFileExtension(fileName);
    return allowedExtList.includes(fileExt);
  }

  // convert admin sort fields to sort string, used by utilities service in backend
  static sortFieldsToString(sortFields: any[], isSnakeField = false): string {
    if (sortFields && sortFields.length > 0) {
      return sortFields.reduce((prev: string, current: any) => {
        const fieldName = isSnakeField ? current.fieldName.replace(/[A-Z]/g, (v: string) => `_${v.toLowerCase()}`) : current.fieldName
        return prev + '&sort=' + fieldName + ',' + current.sort.toUpperCase()
      }, '');
    }
    return '';
  }

  static truncateText(text:string, num: number = 20, replaceText = '...') {
    return text?.replace(new RegExp(`^.{${num}}.*`, 'g'), (v) => {
      return v.substr(0, num) + replaceText
    }) || ''
  }

  static replaceSpecial(value: any) {
    return typeof value == 'string' ? value?.replace(/[_%.^$*+\-?()\[\]{}\\|—\/]/gi, (v: string) => `\\${v}`)?.trim() : value;
  }

  static camelCaseToSnakeCase(key:string):string {
    let result = key.replace( /([A-Z])/g, " $1" )
    return result.split(' ').join('_').toLowerCase()
  }

  static checkExistData(data: any[], fieldId: string, value: any): boolean {
    if (data) {
      const map = new Map();
      data.forEach((x: any) => {
        if (x[fieldId]) {
          map.set(x[fieldId], x);
        }
      });
      return map.has(value);
    }
    return false;
  }

  static trimSpaceData(data: any): any {
    if (data && typeof data === 'string') {
      return data.trim();
    }
    if (data && typeof data === 'object') {
       Object.keys(data).forEach(key => {
        if (data[key] && typeof data[key] === 'string') {
          data[key] = data[key].trim() || null;
        }
      });
    }
    return data;
  }

  static validateNunber(value: any): boolean {
    const reg = new RegExp('^[0-9]*$');
    return reg.test(value);
  }
}
